import { combineReducers } from 'redux';
import types from './types';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';

export interface IOrdersError {
  hasFailed: boolean;
  message: string;
}

const INITIAL_PAGE_NUMBER = 0;
const INITIAL_PAGE_SIZE = 0;
const INITIAL_TOTAL_ELEMENTS = 0;
const INITIAL_TOTAL_PAGES = 0;
const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: IOrdersError = {
  hasFailed: false,
  message: ''
};
const INITIAL_RECENT_ORDERS = [];

const orders = (
  state: IInitialState['orders']['orders'] = INITIAL_STATE.orders.orders || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.CLEAR_ALL:
      return [];
    case types.SET_ORDER: {
      const order = payload as any;
      return [...state, order];
    }
    default:
      return state;
  }
};

const trackingNumbers = (
  state: IInitialState['orders']['trackingNumbers'] = INITIAL_STATE.orders
    .trackingNumbers || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.CLEAR_ALL:
      return [];
    case types.SET_TRACKING_NUMBER: {
      const tn = payload as any;
      return [...state, tn];
    }
    default:
      return state;
  }
};

const pageNumber = (
  state: number = INITIAL_PAGE_NUMBER,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_PAGE_NUMBER:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const pageSize = (
  state: number = INITIAL_PAGE_SIZE,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_PAGE_SIZE:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const totalElements = (
  state: number = INITIAL_TOTAL_ELEMENTS,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_TOTAL_ELEMENTS:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const totalPages = (
  state: number = INITIAL_TOTAL_PAGES,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_TOTAL_PAGES:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const error = (
  state: IOrdersError = INITIAL_ERROR,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_ERROR:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const recentOrders = (
  state: IInitialState['orders']['recentOrders'] = INITIAL_STATE.orders
    .recentOrders || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_RECENT_ORDERS: {
      return payload;
    }
    default:
      return state;
  }
};

export default combineReducers({
  orders,
  recentOrders,
  pageNumber,
  pageSize,
  totalElements,
  totalPages,
  isPending,
  error,
  trackingNumbers
});
